module.exports = __webpack_public_path__ + "static/media/Älvsjö sexuell hälsa has telemedicine software for digital healthcare.4b462981.webp";